exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.changeTitle[data-v-5f9daf94] {\n    font-weight: bold;\n}\n.saveAction[data-v-5f9daf94] {\n    font-weight: bold;\n    color: red;\n}\n", ""]);

// exports
